import React from "react";
import { useLocalization } from "@fluent/react";
import { ContextForm, SimpleDateInput } from "cerulean";
import useRevalidateErroringField from "../hooks/useRevalidateErroringField";

type DobFieldProps = {
  revalidateErrorsOnBlur?: boolean;
};

const DobField = ({ revalidateErrorsOnBlur = false }: DobFieldProps) => {
  const { l10n } = useLocalization();
  const field = "dob";
  const revalidateErroringField = useRevalidateErroringField(field);

  return (
    <ContextForm.Field required key={field}>
      {/* @ts-expect-error certain props are omitted because this is in a ContextForm */}
      <SimpleDateInput
        field={field}
        label={l10n.getString("label-dob", null, "Date of birth (mm/dd/yyyy)")}
        onBlur={revalidateErrorsOnBlur ? revalidateErroringField : undefined}
      />
    </ContextForm.Field>
  );
};

export default DobField;
